import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=97b565d4&scoped=true&"
import script from "./Award.vue?vue&type=script&lang=ts&"
export * from "./Award.vue?vue&type=script&lang=ts&"
import style0 from "./Award.vue?vue&type=style&index=0&id=97b565d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b565d4",
  null
  
)

export default component.exports